import {
  CompactSemantic_getInstance287c07xso9hna as CompactSemantic_getInstance,
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
} from '../models/Theme.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../ViewWrapper.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { replaceqbix900hl8kl as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { timesx4ey3un7ihw1 as times } from '../models/data.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_compact(_this__u8e3s4) {
  return _this__u8e3s4.jbb(CompactSemantic_getInstance());
}
function dynamicTheme(_this__u8e3s4, calculate) {
  var existing = _this__u8e3s4.qb6_1;
  reactiveScope(_this__u8e3s4, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp0_elvis_lhs = calculate($this$reactiveScope);
    _this__u8e3s4.lba(existing.abf(tmp0_elvis_lhs == null ? Companion_getInstance().zd1_1 : tmp0_elvis_lhs));
    return Unit_instance;
  });
}
function withSpacing(_this__u8e3s4, multiplier) {
  // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
  Companion_getInstance();
  var tmp$ret$0 = new (withSpacing$$inlined$invoke$1())(multiplier);
  return _this__u8e3s4.jbb(tmp$ret$0);
}
function themeFromLast(_this__u8e3s4, calculate) {
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    var tmp = _this__u8e3s4.qb6_1;
    // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
    Companion_getInstance();
    var tmp$ret$0 = new (_no_name_provided__qut3iv())(calculate);
    _this__u8e3s4.lba(tmp.abf(tmp$ret$0));
    return Unit_instance;
  };
  Companion_getInstance_0();
  return Companion_getInstance_0();
}
function get_bold(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
  Companion_getInstance();
  var tmp$ret$0 = new (bold$$inlined$invoke$1())();
  return _this__u8e3s4.jbb(tmp$ret$0);
}
function get_italic(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
  Companion_getInstance();
  var tmp$ret$0 = new (italic$$inlined$invoke$1())();
  return _this__u8e3s4.jbb(tmp$ret$0);
}
var withSpacing$$inlined$invoke$1Class;
function withSpacing$$inlined$invoke$1() {
  if (withSpacing$$inlined$invoke$1Class === VOID) {
    class $ {
      constructor($multiplier) {
        this.rdl_1 = $multiplier;
      }
      hd1(theme) {
        return theme.wd1('withgap' + replace(this.rdl_1.toString(), _Char___init__impl__6a9atx(46), _Char___init__impl__6a9atx(95)), VOID, VOID, VOID, times(theme.jb0_1, this.rdl_1)).cb1_1;
      }
    }
    protoOf($).abf = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    withSpacing$$inlined$invoke$1Class = $;
  }
  return withSpacing$$inlined$invoke$1Class;
}
var _no_name_provided__qut3ivClass;
function _no_name_provided__qut3iv() {
  if (_no_name_provided__qut3ivClass === VOID) {
    class $ {
      constructor($calculate) {
        this.sdl_1 = $calculate;
      }
      hd1(theme) {
        return this.sdl_1(theme).ab1_1;
      }
    }
    protoOf($).abf = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    _no_name_provided__qut3ivClass = $;
  }
  return _no_name_provided__qut3ivClass;
}
var bold$$inlined$invoke$1Class;
function bold$$inlined$invoke$1() {
  if (bold$$inlined$invoke$1Class === VOID) {
    class $ {
      hd1(theme) {
        return theme.wd1('bold', theme.gb0_1.vd4(VOID, VOID, true)).cb1_1;
      }
    }
    protoOf($).abf = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    bold$$inlined$invoke$1Class = $;
  }
  return bold$$inlined$invoke$1Class;
}
var italic$$inlined$invoke$1Class;
function italic$$inlined$invoke$1() {
  if (italic$$inlined$invoke$1Class === VOID) {
    class $ {
      hd1(theme) {
        return theme.wd1('italic', theme.gb0_1.fd1(VOID, true)).cb1_1;
      }
    }
    protoOf($).abf = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    italic$$inlined$invoke$1Class = $;
  }
  return italic$$inlined$invoke$1Class;
}
//region block: exports
export {
  get_bold as get_bold1rri6ahk98puv,
  get_compact as get_compact3lsezez8nz8b6,
  dynamicTheme as dynamicThemexp3sdnaolntz,
  get_italic as get_italic11nskfy97pz2f,
  themeFromLast as themeFromLast2to6pl6235w33,
  withSpacing as withSpacing5keoy85vrpk,
};
//endregion

//# sourceMappingURL=themeDerivations.mjs.map
